import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
/** Components */
import Button from 'components/Button';
import Loader from 'components/Loader';
import InvoiceList from './InvoiceList';
/** Services */
import { getSuppliersInvoices } from 'services/invoices';
import { getAllProviders } from 'services/providers';
/** Utils */
import { createToast } from 'utils/toast';
/** Styles */
import styles from './Invoices.module.scss';

const Invoices = () => {
  const [invoiceList, setInvoiceList] = useState([]);
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllProviders()
      .then(({ data: { fetchedSuppliers } }) => {
        setProviders(fetchedSuppliers);
        setLoading(false);
      })
      .catch(({ status, response }) => {
        setLoading(false);
        if (status === 401) {
          createToast({
            text: 'No tienes suficientes permisos',
            type: 'error',
          });
          return;
        }

        createToast({ text: response.data.feedback, type: 'error' });
      });

    getSuppliersInvoices()
      .then(({ data }) => {
        setInvoiceList(data);
        setLoading(false);
      })
      .catch(({ status, response }) => {
        setLoading(false);
        if (status === 401) {
          createToast({
            text: 'No tienes suficientes permisos',
            type: 'error',
          });
          return;
        }

        createToast({ text: response.data.feedback, type: 'error' });
      });
  }, []);

  const handleDeleteInvoices = (ids) => {
    setInvoiceList(invoiceList.filter((invoice) => !ids.includes(invoice.id)));
  };

  return loading ? (
    <Loader />
  ) : (
    <div className={styles.Invoices}>
      <div className={styles.InvoicesHeader}>
        <h1 className="title">Facturas de proveedores</h1>
        <NavLink to="/proveedores/facturas/nuevo">
          <Button update text="Crear nueva" />
        </NavLink>
      </div>
      <div className={styles.InvoicesList}>
        <InvoiceList
          invoices={invoiceList}
          providers={providers}
          onDeleteInvoices={handleDeleteInvoices}
        />
      </div>
    </div>
  );
};

export default Invoices;
